<template>
  <div>
    <div class="mx-auto max-w-3xl px-7 py-5 md:mb-5 md:mt-7">
      <slot name="title"></slot>
      <slot name="body"></slot>

      <p :class="{ invisible: !error }" class="mb-0 text-sm text-red-500">
        Please type in the search box and select a keyword to proceed
      </p>
      <v-autocomplete
        v-model="searchModel"
        v-model:search="searchInput"
        :class="error ? 'error' : ''"
        class="keyword-input"
        :loading="searchLoading"
        :items="searchItems"
        data-cy="consult.keywordsearch.input.search-roles"
        variant="outlined"
        clearable
        hide-no-data
        menu-icon=""
        placeholder="Start typing tasks, roles, skills or tools …"
        :persistent-hint="true"
        @keyup.enter="updateSelectedKeyword(searchInput)"
      >
        <template #prepend-inner>
          <fa-icon
            icon="fa-regular fa-magnifying-glass"
            class="text-vgstone -mt-1 pr-2 text-lg"
          />
        </template>
        <template #append-inner>
          <fa-icon
            icon="fa-regular fa-circle-plus"
            class="text-vgstone -mt-1 pl-2 text-xl"
            @click="updateSelectedKeyword(searchInput)"
          />
        </template>
      </v-autocomplete>
    </div>
  </div>
</template>
<script>
import { searchKeywords } from '@/services/matchingService';
import { mapStores } from 'pinia';
import { useCheckoutStore } from '@/stores/checkout';

export default {
  name: 'KeywordSearch',
  props: {
    error: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['showNext'],
  data() {
    return {
      searchModel: null,
      searchItems: [],
      searchInput: null,
      searchLoading: false,
    };
  },
  computed: {
    ...mapStores(useCheckoutStore),
  },
  watch: {
    searchInput(val) {
      val &&
        !this.searchItems.find((item) => item.title === val) &&
        this.handleSkillSearch(val);
      this.$emit('showNext');
    },
    searchModel: function () {
      if (this.searchModel) {
        let result = this.searchItems.find(
          (item) => item.title === this.searchModel
        );
        if (!result) {
          return;
        }

        this.updateSelectedKeyword({
          keyword: result.title,
          criteria: result.type,
          description: result.description ?? '',
          id: result.id,
        });
      }
    },
  },

  methods: {
    updateSelectedKeyword(selected) {
      if (!selected) {
        return;
      }

      this.searchItems = [];
      this.searchInput = '';
      this.searchModel = '';

      this.checkoutStore.selectKeyword({
        keyword: selected.keyword ?? selected,
        criteria: selected.criteria ?? 'default',
        description: selected.description ?? '',
        id: selected.id ?? null,
      });
      this.$gtm?.trackEvent({
        event: 'DL - Consult - Enters keyword',
        value: selected.keyword,
      });
    },
    async handleSkillSearch(searchInput) {
      this.searchLoading = true;
      const searchResults = await searchKeywords([
        `searchQuery=${encodeURIComponent(searchInput)}`,
      ]).catch((error) => {
        this.$root.$snackbar.error(
          error?.data?.message ?? 'An Error occurred, please try again later.'
        );
        return [];
      });
      this.searchItems = searchResults
        .filter(
          (item) =>
            !this.checkoutStore.flattedEnteredKeywords?.some(
              (keyword) => keyword === item.value
            )
        )
        .map((item) => {
          return {
            title: item.value,
            type: item.type,
            id: item.id,
          };
        });
      this.searchLoading = false;
    },
  },
};
</script>
<style scoped>
* :deep(.v-messages__message) {
  @apply text-vgorange;
}

* :deep(.error.v-text-field fieldset) {
  color: red !important;
}

* :deep(.v-text-field > .v-input__control fieldset) {
  padding-left: 40px;
}
</style>
